<template>
  <section class="section">
    <div class="container">
      <div class="column">
        <h1 v-if="!showNoPolicyMsg" class="title has-text-centered">
          Which quote would you like to view?
        </h1>
        <div v-if="!showNoPolicyMsg">
          <p v-for="quote in quotesToRetrieve" v-bind:key="quote.policyNumber">
            <button
              type="button"
              class="button-primary button-primary--black button-primary--stretch"
              @click="selectedQuote(quote)"
            >
              <span class="button-primary__icon icon icon--arrow-right-hair">
                <span class="loader-base button-primary__loader"></span>
              </span>
              <span class="button-primary__label">
                Policy #{{ quote.policyNumber }}
              </span>
            </button>
          </p>
        </div>
        <div v-else class="error-msg-box">
          <h1 class="title has-text-centered">
            You do not have any current quotes.
          </h1>
          <button
            v-if="!showMultiplePolicies"
            type="button"
            class="button-primary button-primary--black button-primary errorBtn"
            @click="goToAccount"
          >
            View my policy
          </button>
          <button
            v-else
            type="button"
            class="button-primary button-primary--black button-primary errorBtn"
            @click="goToMultiplePolicies"
          >
            View my policies
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import * as _ from 'lodash';

export default {
  name: 'LookupQuotes',
  data: () => ({
    showNoPolicyMsg: false,
    showMultiplePolicies: false
  }),
  computed: {
    ...mapGetters(['policies']),
    quotesToRetrieve() {
      let quoteNums = this.policies.map(function(policy) {
        return policy.fromQuoteNumber && policy.fromQuoteNumber.toUpperCase();
      });
      let filtered = _.cloneDeep(this.policies);
      for (let i = 0; i < filtered.length; i++) {
        if (
          (filtered[i].policyStatus === 'QUOTE' &&
            quoteNums.includes(filtered[i].policyNumber)) ||
          filtered[i].policyStatus !== 'QUOTE'
        ) {
          Vue.delete(filtered, i);
          i--;
        }
      }
      if (filtered.length === 0) {
        if (this.policies.length > 1) {
          this.toggleMultiplePoliciesMsg(true);
        } else {
          this.toggleMultiplePoliciesMsg(false);
        }
        this.toggleNoPolicyMsg(true);
      } else {
        this.toggleNoPolicyMsg(false);
      }
      return filtered;
    }
  },
  methods: {
    ...mapMutations(['setSelectedPolicy']),
    toggleNoPolicyMsg(status) {
      this.showNoPolicyMsg = status;
    },
    toggleMultiplePoliciesMsg(status) {
      this.showMultiplePolicies = status;
    },
    selectedQuote(quote) {
      this.$store.commit('updateQuoteResponse', { policies: [quote] });
      this.$router.push({
        path: '/receive-a-quote',
        query: {
          email: quote.emailAddress.toLowerCase(),
          dob: quote.driverInfo[0].dob,
          zipcode: quote.addressInfo[0].zip
        }
      });
    },

    goToMultiplePolicies() {
      this.$router.push('/account/multiple-policies');
    },

    goToAccount() {
      this.$router.push('/account');
    }
  }
};
</script>

<style lang="scss" scoped>
.button-primary {
  max-width: 500px;
}

.error-msg-box {
  display: flex;
  margin-top: 10.5rem;
  flex-grow: inherit;
  flex-flow: column;
  padding: 0 4%;
}

.errorBtn {
  align-self: flex-end;
}
</style>
